import React from 'react';

// ログアウト後のページコンポーネント
const LogoutPage: React.FC = () => {
  const handleLoginRedirect = () => {
    // 念のためストレージをクリア
    localStorage.clear();
    sessionStorage.clear();
    
    // ルートに遷移（認証が必要なため自動的にログイン画面に遷移する）
    window.location.href = '/';
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <h2 style={{ color: '#333', marginBottom: '20px' }}>ログアウト完了</h2>
        <p style={{ color: '#666', marginBottom: '30px' }}>
          正常にログアウトしました。<br />
          再度ログインする場合は、下のボタンをクリックしてください。
        </p>
        <button 
          onClick={handleLoginRedirect}
          style={{
            padding: '12px 24px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          ログイン画面へ
        </button>
      </div>
    </div>
  );
};

export default LogoutPage;
